// Dawn handles opening, Escape, backdrop and focus restoration. Keep Tab inside
// these compact panels, including the case with only one focusable close button.
if (!window.cpProductInfoFocusGuard) {
  window.cpProductInfoFocusGuard = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const modal = document.querySelector('.cp-product-info-modal[open]');
    if (!modal) return;
    const elements = getFocusableElements(modal).filter(element => element.getClientRects().length);
    const index = elements.indexOf(document.activeElement);
    if (index === -1 || (event.shiftKey ? index === 0 : index === elements.length - 1)) {
      event.preventDefault();
      event.stopPropagation();
      (event.shiftKey ? elements.at(-1) : elements[0])?.focus();
    }
  }, true);
}
